import { motion, useScroll, useSpring } from 'motion/react';
import { site } from '../data/site';
import { useScroll as useSiteScroll } from '../hooks/useScrollContext';
import useScrollSpy from '../hooks/useScrollSpy';
import { usePrefersReducedMotion } from '../effects/motionConfig';

export default function SideRail() {
  const sectionIds = ['hero', ...site.nav.map((n) => n.id)];
  const activeId = useScrollSpy(sectionIds, 140);
  const { scrollToSection } = useSiteScroll();
  const reduced = usePrefersReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleY = useSpring(scrollYProgress, { stiffness: 120, damping: 28, restDelta: 0.001 });
  const year = new Date().getFullYear();

  return (
    <aside className="side-rail" aria-label="Site navigation">
      <button
        type="button"
        className="side-rail__brand"
        onClick={() => scrollToSection('hero')}
        aria-label="Home"
      >
        <img src={site.logo} alt="" />
        <span className="side-rail__name">{site.name}</span>
      </button>

      <nav className="side-rail__nav" aria-label="Sections">
        {site.nav.map(({ id, label }) => {
          const isActive = activeId === id;
          return (
            <button
              key={id}
              type="button"
              className={`side-rail__link ${isActive ? 'side-rail__link--active' : ''}`}
              onClick={() => scrollToSection(id, { align: 'center' })}
              aria-current={isActive ? 'true' : undefined}
            >
              <span className="side-rail__link-bar" aria-hidden="true" />
              {label}
            </button>
          );
        })}
      </nav>

      <div className="side-rail__progress" aria-hidden="true">
        {!reduced && (
          <motion.div className="side-rail__progress-fill" style={{ scaleY, transformOrigin: 'top' }} />
        )}
      </div>

      <div className="side-rail__footer">
        <p className="side-rail__status">{site.availability}</p>
        <p className="side-rail__copy">&copy; {year}</p>
      </div>
    </aside>
  );
}
